import { jsx as _jsx } from "react/jsx-runtime";
import classnames from 'classnames';
import styles from './Box.module.scss';
const Box = ({ boxWrapperClassName = '', children, className = '', id = undefined, isFluid = false, ...restProps }) => {
    const div = (_jsx("div", { className: classnames(isFluid ? 'container-fluid' : 'container', styles.boxBackground, className), id: id, ...restProps, children: children }));
    if (!isFluid && boxWrapperClassName)
        return _jsx("div", { className: boxWrapperClassName, children: div });
    return div;
};
export { Box };
